import { PlainRangeInterface } from '../models/range.interface';

export function rangeFromString<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
>(value: string): PlainRangeInterface<StartBoundary, EndBoundary> {
  const range = value.replace(' ', '').match(/^([([])(.*?),(.*?)([)\]])$/);

  if (!range) {
    throw new Error(`The value "${value}" is not a valid range`);
  }

  return {
    start: range[2] === '' ? null : range[2],
    end: range[3] === '' ? null : range[3],
    inclusiveStart: range[1] === '[',
    inclusiveEnd: range[4] === ']',
  } as PlainRangeInterface;
}
